import NewRecurringOrder from './NewRecurringOrder'

export default NewRecurringOrder



// WEBPACK FOOTER //
// ./src/components/RecurringOrders/New/index.js